import { takeEvery, fork, put, all, call, delay } from "redux-saga/effects"
const { ADD_MUTUAL_FUND_START, UPDATE_MUTUAL_FUND_START, VIEW_CUSTOMER_MUTUAL_FUND_START, VIEW_SINGLE_MUTUAL_FUND_START, MUTUAL_FUND_REPORT_START } = require("./constant")
const { addMutualFundSuccess, addMutualFundFailure, updateMutualFundSuccess, updateMutualFundFailure, viewCustomerMutualFundFailure, viewCustomerMutualSuccess, viewSingleMutualFundSuccess, viewSingleMutualFundFailure, mutualFundReportSuccess, mutualFundReportFailure } = require("./action")
const { addMutualFundAPI, updateMutualFundAPI, viewCustomerMutualFundAPI, ViewSingleMutualFundAPI, mutualFundReportAPI } = require("./api")


function* addMutualFundAsync(action) {
    try {
        const response = yield call(addMutualFundAPI, action.payload)
            if (response.status === 201) {
            yield put(addMutualFundSuccess(response.data))
        } else {
            yield put(addMutualFundFailure(error.response.data))
        }
    } catch (error) {
        yield put(addMutualFundFailure(error.response.data))
    }
}

function* addMutualFund() {
    yield takeEvery(ADD_MUTUAL_FUND_START, addMutualFundAsync)
}



function* updateMutualFundAsync(action) {
    try {
        const response = yield call(updateMutualFundAPI, action.payload)
            if (response.status === 200) {
            yield put(updateMutualFundSuccess(response.data))
        } else {
            yield put(updateMutualFundFailure(error.response?.data))
        }
    } catch (error) {
        yield put(updateMutualFundSuccess(error.response.data))
    }
}

function* updateMutualFund() {
    yield takeEvery(UPDATE_MUTUAL_FUND_START, updateMutualFundAsync)
}


function* viewCustomerMutualFundAsync(action) {
    try {
        const response = yield call(viewCustomerMutualFundAPI, action.payload)

        if (response.status === 200) {
            yield put(viewCustomerMutualSuccess(response.data.data)) // send only array
        } else {
            throw response
        }
    } catch (error) {
        yield put(viewCustomerMutualFundFailure(error))
    }
}

function* viewCustomerMutualFund() {
    yield takeEvery(VIEW_CUSTOMER_MUTUAL_FUND_START, viewCustomerMutualFundAsync)
}


function* viewSingleMutualFundAsync(action) {
    try {
        const response = yield call(ViewSingleMutualFundAPI, action.payload)

        if (response.status === 200) {
            yield put(
                viewSingleMutualFundSuccess(response.data.data?.[0] || null)
            )
        } else {
            throw response
        }
    } catch (error) {
        yield put(viewSingleMutualFundFailure(error))
    }
}

function* viewSingleMutualFund() {
    yield takeEvery(VIEW_SINGLE_MUTUAL_FUND_START, viewSingleMutualFundAsync)
}


function* mutualFundReportAsync(action) {
    try {
        const response = yield call(mutualFundReportAPI, action.payload);

        // axios success = HTTP 200
        if (response.status === 200 && response.data.status === 1) {
            yield put(mutualFundReportSuccess(response.data.data));
        } else {
            yield put(mutualFundReportFailure(response.data.message));
        }
    } catch (error) {
        yield put(
            mutualFundReportFailure(
                error?.response?.data?.message || "Unable to fetch Mutual Fund Report"
            )
        );
    }
}

function* mutualFundReport() {
    yield takeEvery(MUTUAL_FUND_REPORT_START, mutualFundReportAsync);
}




function* mutualFundSaga() {
    yield all ([
        fork(addMutualFund),
        fork(updateMutualFund),
        fork(viewCustomerMutualFund),
        fork(viewSingleMutualFund),
        fork(mutualFundReport),
    ])
}

export default mutualFundSaga